import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride();

export default metaOverrideSet;
